"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function memoize(provider, isExpired, requiresRefresh) {
  if (isExpired === undefined) {
    // This is a static memoization; no need to incorporate refreshing
    var result_1 = provider();
    return function () {
      return result_1;
    };
  }
  var result = provider();
  var isConstant = false;
  return function () {
    if (isConstant) {
      return result;
    }
    return result.then(function (resolved) {
      if (requiresRefresh && !requiresRefresh(resolved)) {
        isConstant = true;
        return resolved;
      }
      if (isExpired(resolved)) {
        return result = provider();
      }
      return resolved;
    });
  };
}
exports.memoize = memoize;